<template>
  <div class="upload com">
    <el-button type="primary" @click="addData" size="small">Add</el-button>
    <div v-for="(item, idx) in fileList" :key="idx" class="uploader-list">
      <cc-uploader
        :config="uploaderConf"
        ref="uploader"
        v-model="fileList[idx].link"
        @change="updateItem(item, idx)"
      />
    </div>
  </div>
</template>

<script>
let Base64 = require("js-base64").Base64;

import ossUtils from "../../../../utils/ossUtils";
export default {
  name: "FormUploader",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: String,
    formData: Object,
  },
  watch: {
    value: {
      handler(val) {
        this.fileList = this.parse2Json(val);
      },
      immediate: true,
      deep: true,
    },
    formData: {
      handler(val) {
        let url = "/perm/sisMerchant/";
        if (this.formData.merchantNum) {
          url = "/perm/sisMerchant/" + this.formData.merchantNum + "/";
        }
        this.uploaderConf = ossUtils.configPublishV2(url);
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      fileList: this.parse2Json(this.value),
      uploaderConf: ossUtils.configPublish,
      fileName:""
    };
  },
  methods: {
    parse2Json(val) {
      try {
        return JSON.parse(val);
      } catch (error) {
        return [];
      }
    },
    addData() {
      this.fileList.push({ link: "", name: "" });
    },
    emitUploaderData(arr) {
      this.$emit("change", JSON.stringify(arr));
    },
    updateItem(item, idx) {
      // console.log(item,222222222)
      if (!item.link) {
        this.fileList.splice(idx, 1);
        this.emitUploaderData(this.fileList);

        // this.uploaderData.splice(idx, 1);
        return;
      }
      // 上传图片手动触发同步更新操作
      // const arr = this.uploaderData;
      const i = this.fileList[idx];
      i.link = item.link;
      i.name = item.link.split("/").pop();
      i.name=Base64.decode(i.name.split(".")[0]);
      i.name=i.name.split("_")[1];
      alert( i.name)
      this.emitUploaderData(this.fileList);
    },

  },
  mounted() {},
};
</script>

<style scoped>
.uploader-list {
  margin: 4px 0;
}
</style>
<style lang="scss">
.com {
  .upload-btnV2 .upload-demo {
    margin-top: -21px !important;
  }
}
</style>